module.exports = __webpack_public_path__ + "img/中国工商银行.686f4740.png";